import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

import LinkComponent from '../LinkComponent/LinkComponent'
import {
  treatmentCard,
  treatmentCardContent,
  treatmentCardImage,
  treatmentCardTitle,
} from './PromotedTreatment.module.css'

const PromotedTreatment = ({ defaultData, treatment }) => {
  const image = getImage(
    treatment.herocontent.herocontentimage.node.localFile.childImageSharp
      .gatsbyImageData,
  )

  return (
    <LinkComponent
      className={treatmentCard}
      src={defaultData ? treatment.pageType.uri : treatment.uri}
    >
      {image && (
        <GatsbyImage
          alt={treatment.herocontent.herocontentimage.node.altText}
          className={treatmentCardImage}
          image={image}
        />
      )}
      <h3 className={treatmentCardTitle}>
        {defaultData ? treatment.title : treatment.promoteddata?.title}
      </h3>
      <p className={treatmentCardContent}>
        {defaultData
          ? treatment.seo.metaDesc
          : treatment.promoteddata?.description}
      </p>
    </LinkComponent>
  )
}

export default PromotedTreatment
